import { TConstraints } from 'app/common/constraints/core/constraints';
import { INotifications } from 'app/common/notifications/core/notifications';
import { HttpClient, HttpRequest } from 'app/libs/http-client';
import { TRoleNames } from 'app/railways/domains/access/features/roles/roles';

import {
  TEntityGridColumn,
  TEntityGridConstraints,
  TEntityGridExtraFilter,
  TEntityGridRowModels,
} from '../../core';
import { EntityGridColumns } from '../../modules/entity-grid-columns';
import { EntityGridConstraints } from '../../modules/entity-grid-constraints';
import { EntityGridExtraFilters } from '../../modules/entity-grid-extra-filters';
import { ListEntityResource } from '../../resources/entity-list.resource';

type EntityGridConfigParams = TEntityGridRowModels & {
  columns: TEntityGridColumn[];
  userRoles: TRoleNames[];

  apiClient: HttpClient;
  notify: INotifications;
  request: (constraints?: TConstraints<any, any>) => HttpRequest;

  extraFilters?: TEntityGridExtraFilter[];
  initialState?: TEntityGridConstraints;
};

export class EntityGridConfig {
  public columns: EntityGridColumns;
  public constraints: EntityGridConstraints;
  public extraFilters: EntityGridExtraFilters;

  public resource: ListEntityResource<any, any, any>;

  constructor(params: EntityGridConfigParams) {
    this.constraints = new EntityGridConstraints(params);
    this.columns = new EntityGridColumns(params);

    this.extraFilters = new EntityGridExtraFilters({
      extraFilters: params.extraFilters || [],
      userRoles: params.userRoles,
    });

    this.resource = new ListEntityResource<any, any, any>({
      apiClient: params.apiClient,
      httpRequest: params.request,
      notify: params.notify,
      constraints: this.constraints,
    });
  }

  dispose() {
    this.resource.dispose();
  }
}
